// extracted by mini-css-extract-plugin
module.exports = {"useFade-fadeIn":"GroupedProductList_useFade-fadeIn__bmu_Y","useFade-fadeOut":"GroupedProductList_useFade-fadeOut__lmybe"};